export function clone(object) {
  return JSON.parse(JSON.stringify(object));
}

export function trunc(valor, decimais = 2) {
  let dec = Math.pow(10, decimais);
  return Number((Math.round(valor * dec) / dec).toFixed(decimais));
}

export function abrirJanela(url) {
  window.open(url, '_blank');
}

export function copyText(elemento_id) {
  window.getSelection().selectAllChildren(document.getElementById(elemento_id));
  document.execCommand('copy');
  window.getSelection().removeAllRanges();
}

export function hoje() {
  let data = new Date();
  return data.getFullYear() + '-' + (data.getMonth() + 1).toString().padStart(2, '0') + '-' + data.getDate().toString().padStart(2, '0');
}

export function hora() {
  return new Date().toLocaleTimeString().substr(0, 5);
}

export function mesExtenso(mes = (new Date()).getMonth() - 1) {
  const meses = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"];
  return meses[mes - 1];
}

export function setFocus(field, timeout = 0) {
  setTimeout(() => {
    field.focus();
  }, timeout);
}

export function selectText(field) {
  setTimeout(() => {
      this.field.selectionStart = 0;
      this.field.selectionEnd   = this.field.value.length;
  }, 0)
}

export function parsePermissoes(menu) {

  const permissoes_rotas = [];
  menu.forEach(item => {

    if (item.itens?.length > 0) {
      item.itens.forEach(element => {
        if (!element.disabled) {
          permissoes_rotas.push({
            name: element.to?.name,
            permissao: element.permissao
          });
        }
      });
    }
  })

  return permissoes_rotas;
}

export function range(start, end) {
  if (start > end) {
    return Array.from({length: start - end + 1}, (_, i) => start - i);
  } else {
    return Array.from({length: end - start + 1}, (_, i) => start + i);
  }
}

/**
 * 
 * @param {Array} array 
 * @param {String} find_field 
 * @param {Number} id 
 */
export function find_id(array, find_field, id) {
  const object = array.find(element => element[find_field] === id);

  return object || {}
}

export function gerarTerminais(start = 1, end = 32) {
  return range(start, end).map(item => item.toString().padStart(3, "0"));
}

// Elimina os campos vazios do objeto
export function parseParams(params) {
  if (params) {
    return Object.fromEntries(
      Object.entries(params).filter(([key, value]) => value)
    );
  }
}

export async function generateUniqueId() {
  // Informações básicas do navegador
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;
  const language = navigator.language;
  const cpuClass = navigator.hardwareConcurrency || 'unknown';
  const deviceMemory = navigator.deviceMemory || 'unknown';
  const screenResolution = `${screen.width}x${screen.height}x${screen.colorDepth}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Tamanho da janela
  const windowSize = `${window.innerWidth}x${window.innerHeight}`;

  // Coletar fontes disponíveis
  const fonts = ['Arial', 'Courier', 'Times', 'Georgia', 'Verdana', 'Trebuchet'].filter(font => {
      const span = document.createElement('span');
      span.style.fontFamily = font;
      span.innerHTML = 'abcdefghijklmnopqrstuvwxyz';
      document.body.appendChild(span);
      const width = span.offsetWidth;
      document.body.removeChild(span);
      return width > 0;
  }).join(',');

  // Canvas Fingerprinting
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'top';
  ctx.font = '16px Arial';
  ctx.textBaseline = 'alphabetic';
  ctx.fillStyle = '#f60';
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = '#069';
  ctx.fillText('Hello, world!', 2, 15);
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
  ctx.fillText('Hello, world!', 4, 17);
  const canvasFingerprint = canvas.toDataURL();

  // Áudio Fingerprinting (silencioso)
  let audioFingerprint = 'unknown';
  try {
      const audioCtx = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 44100, 44100);
      const oscillator = audioCtx.createOscillator();
      const analyser = audioCtx.createAnalyser();
      const gain = audioCtx.createGain();
      gain.gain.value = 0; // Mutar o som

      oscillator.type = 'triangle';
      oscillator.frequency.setValueAtTime(10000, audioCtx.currentTime);

      oscillator.connect(analyser);
      analyser.connect(gain);
      gain.connect(audioCtx.destination);

      oscillator.start(0);
      const buffer = await audioCtx.startRendering();
      const data = new Float32Array(analyser.frequencyBinCount);
      analyser.getFloatFrequencyData(data);
      audioFingerprint = Array.from(data).join(',');
  } catch (e) {
      console.error('Erro ao gerar o fingerprint de áudio:', e);
  }

  // WebGL Fingerprinting
  const glCanvas = document.createElement('canvas');
  const gl = glCanvas.getContext('webgl') || glCanvas.getContext('experimental-webgl');
  const glFingerprint = gl ? gl.getParameter(gl.VERSION) : 'unknown';

  // Concatenar todas as informações
  const rawId = `${userAgent}-${platform}-${language}-${cpuClass}-${deviceMemory}-${screenResolution}-${timezone}-${windowSize}-${fonts}-${canvasFingerprint}-${audioFingerprint}-${glFingerprint}`;

  // Hash da string e codificação em Base64
  const encoder = new TextEncoder();
  const data = encoder.encode(rawId);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashBase64 = btoa(String.fromCharCode(...hashArray));

  // Retornar o hash em Base64
  return hashBase64;
}

